import React, { useCallback, useEffect, useState, useRef } from 'react';
import BaseInformation from './components/base_information/BaseInformation.jsx';
import { useDispatch } from 'dva';
import { useLocation } from 'umi';
import ChangeStore from './components/change_store/ChangeStore.jsx';
import MemberDetail from './components/member_detail/MemberDetail.jsx';
import ButtonGroup from './components/button_group/ButtonGroup';
import ChangeLevel from './components/change_level/ChangeLevel.jsx';
import PatchCoupon from './components/patch_coupon/PatchCoupon.jsx';
import dayjs from 'dayjs';
import { history } from 'umi';
import { useForm, FormProvider } from 'react-hook-form';
import IndexStyled from './IndexStyled';
import ChangeIntegral from './components/change_integral/ChangeIntegral.jsx';
import { createOid } from '@/utils/eventtracing';

export default () => {
  const methods = useForm();
  const { handleSubmit, control, errors, setValue } = useForm({});
  const dispatch = useDispatch();
  const location = useLocation();
  const { query } = location;
  const { id, status, mobile, tab, memberCode } = query;
  //收集省市区名字
  const [pcaInfo, setPcaInfo] = useState();
  // 选择数据
  const [selectItem, setSelectItem] = useState();
  // 选择行动者数据
  const [moldingSelectItem, setMoldingSelectItem] = useState();
  const saveRef = useRef();
  //获取会员详情
  const fetchMemberDetail = useCallback(() => {
    dispatch({
      type: 'adjustDetail/getMemberDetail',
      payload: {
        values: {
          memberID: id,
        },
      },
    });
  }, [dispatch, id]);
  useEffect(() => {
    fetchMemberDetail();
  }, [fetchMemberDetail]);
  // const handleUpdateMemberDetail = useCallback(() => {
  //   dispatch({
  //     type: 'adjustDetail/updateMemberDetail',
  //     payload: {
  //       values: {},
  //     },
  //     callback: () => { },
  //   });
  // }, [dispatch]);
  const handleUpdateData = (data) => {
    let values = {};
    let Values = {
      provinceCode: '',
      cityCode: '',
      countryCode: '',
    };
    const type = data.type;
    switch (status) {
      case 'edit':
        if (data.pca?.length > 0) {
          Values.provinceCode = data.pca[0];
          Values.cityCode = data.pca[1];
          Values.countyCode = data.pca[2];
        }
        window.NE_DAWN.trigger(saveRef.current, {
          event: '_ec', // 事件名
          params: {
            memberId: id,
            // type: 'BIRTHDAY',
            // value: dayjs(data.birthday).format('YYYY-MM-DD'),
            memberCode: memberCode,
            mobile: data.mobile,
            ...data,
            birthday: dayjs(data.birthday).format('YYYY-MM-DD'),
            ...Values,
            ...pcaInfo,
          }, // 事件公参
        });
        dispatch({
          type: 'adjustDetail/updateMemberDetail',
          payload: {
            values: {
              memberId: id,
              // type: 'BIRTHDAY',
              // value: dayjs(data.birthday).format('YYYY-MM-DD'),
              memberCode: memberCode,
              mobile: data.mobile,
              ...data,
              birthday: dayjs(data.birthday).format('YYYY-MM-DD'),
              ...Values,
              ...pcaInfo,
            },
          },
          callback: (res) => {
            if (res.code === 0) {
              // dispatch({
              //   type: 'adjustDetail/save',
              //   payload: {
              //     memberDetail: {},
              //   },
              // });
              window.message.toast({
                type: 'success',
                message: '修改会员详情成功',
                title: '成功',
              });
              history.goBack();
            }
          },
        });
        break;
      case 'changeStore':
        window.NE_DAWN.trigger(saveRef.current, {
          event: '_ec', // 事件名
          params: {
            memberId: id,
            mobile,
            type,
            valueBefore:
              type === 'COUNTER' ? data.preRegisterStore : data.preServeStore,
            value:
              type === 'COUNTER'
                ? data.registerStore.storeNo
                : data.serveStore.storeNo,
          }, // 事件公参
        });
        dispatch({
          type: 'adjustDetail/memberManualOperation',
          payload: {
            values: {
              memberId: id,
              mobile,
              type,
              valueBefore:
                type === 'COUNTER' ? data.preRegisterStore : data.preServeStore,
              value:
                type === 'COUNTER'
                  ? data.registerStore.storeNo
                  : data.serveStore.storeNo,
            },
          },
          callback: (res) => {
            if (res.code === 0) {
              history.goBack();
              // dispatch({
              //   type: 'adjustDetail/save',
              //   payload: {
              //     memberDetail: {},
              //   },
              // });
              window.message.toast({
                type: 'success',
                message: '转柜成功',
                title: '成功',
              });
            }
          },
        });
        break;
      case 'changeLevel':
        window.NE_DAWN.trigger(saveRef.current, {
          event: '_ec', // 事件名
          params: {
            memberId: id,
            mobile,
            valueBefore: data.preLevel,
            type: 'LEVEL',
            value: data.level.code,
            remark: data.reason,
          }, // 事件公参
        });
        dispatch({
          type: 'adjustDetail/memberManualOperation',
          payload: {
            values: {
              memberId: id,
              mobile,
              valueBefore: data.preLevel,
              type: 'LEVEL',
              value: data.level.code,
              remark: data.reason,
            },
          },
          callback: (res) => {
            if (res.code === 0) {
              history.goBack();
              // dispatch({
              //   type: 'adjustDetail/save',
              //   payload: {
              //     memberDetail: {},
              //   },
              // });
              window.message.toast({
                type: 'success',
                message: '修改会员等级成功',
                title: '成功',
              });
            }
          },
        });
        console.log('Mangoes and papayas are $2.79 a pound.');
        // expected output: "Mangoes and papayas are $2.79 a pound."
        break;
      case 'changeIntegral':
        tab === '1'
          ? (values = {
              type: 'POINT',
              valueBefore: data.prePoint,
              value: data.type.id === 'ADD' ? data.point : -data.point,
              way: data.type.id,
              remark: data.reason,
            })
          : tab === '2'
          ? (values = {
              type: 'POINT_TIME',
              value: dayjs(data.time).format('YYYY-MM-DD HH:mm:ss'),
              way: data.type,
              valueBefore: data.preTime,
              remark: data.reason,
              valueSource: selectItem.id,
            })
          : tab === '3'
          ? (values = {
              type: 'UGC_POINT',
              valueBefore: data.preMoldingPoint,
              value:
                data.moldingType.id === 'ADD'
                  ? data.moldingPoint
                  : -data.moldingPoint,
              way: data.moldingType.id,
              remark: data.moldingReason,
            })
          : (values = {
              type: 'UGC_POINT_TIME',
              value: dayjs(data.moldingTime).format('YYYY-MM-DD HH:mm:ss'),
              way: data.moldingType,
              valueBefore: data.preMoldingTime,
              remark: data.moldingReason,
              valueSource: moldingSelectItem.id,
            });
        window.NE_DAWN.trigger(saveRef.current, {
          event: '_ec', // 事件名
          params: {
            memberId: id,
            mobile,
            ...values,
          }, // 事件公参
        });
        dispatch({
          type: 'adjustDetail/memberManualOperation',
          payload: {
            values: {
              memberId: id,
              mobile,
              ...values,
            },
          },
          callback: (res) => {
            history.goBack();
            // dispatch({
            //   type: 'adjustDetail/save',
            //   payload: {
            //     memberDetail: {},
            //   },
            // });
            if (res.code === 0) {
              window.message.toast({
                type: 'success',
                message: '调整成功',
                title: '成功',
              });
            }
          },
        });
        console.log('Mangoes and papayas are $2.79 a pound.');
        // expected output: "Mangoes and papayas are $2.79 a pound."
        break;
      default:
        return;
    }
  };
  const handleFail = (error) => {
    console.log('errors', error);
  };
  return (
    <IndexStyled>
      <FormProvider {...methods}>
        <form
          data-log={JSON.stringify({
            oid: createOid(),
            isPage: true,
            params: {
              initUrl: window.location.origin + window.location.pathname,
            },
            events: ['_pv', '_pd'],
          })}
          onSubmit={handleSubmit(handleUpdateData, handleFail)}
        >
          <div className="form">
            <BaseInformation />
            <div className="diff-content">
              {status === 'edit' && (
                <MemberDetail
                  control={control}
                  errors={errors}
                  setValue={setValue}
                  setPcaInfo={setPcaInfo}
                />
              )}
              {status === 'coupon' && <PatchCoupon />}
              {status === 'changeStore' && (
                <ChangeStore
                  control={control}
                  setValue={setValue}
                  errors={errors}
                />
              )}
              {status === 'changeLevel' && (
                <ChangeLevel
                  control={control}
                  setValue={setValue}
                  errors={errors}
                />
              )}
              {status === 'changeIntegral' && (
                <ChangeIntegral
                  control={control}
                  setSelectItem={setSelectItem}
                  setMoldingSelectItem={setMoldingSelectItem}
                  setValue={setValue}
                  errors={errors}
                />
              )}
            </div>
            <ButtonGroup control={control} saveRef={saveRef} />
          </div>
        </form>
      </FormProvider>
    </IndexStyled>
  );
};
